const isDevelopment = () => process.env.NODE_ENV === "development";

export default isDevelopment;
